var map = {
	"./how-bars-restaurants-coffee-shops-and-food-trucks-can-use-photo-and-video-to-attract-more-customers.mdx": 384,
	"./why-brand-and-testimonial-videos-are-a-must-have-for-service-businesses.mdx": 385,
	"./why-every-small-business-needs-professional-photo-and-video-content.mdx": 845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 575;